var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "ReleaseJY",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ContainerPreloadJY"),
        "close-on-click-modal": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c(
        "div",
        { staticStyle: { margin: "10px" } },
        _vm._l(_vm.containers, function(item, index) {
          return _c(
            "span",
            { key: index, staticStyle: { fontWeight: "bold" } },
            [
              _c("span", [_vm._v(" " + _vm._s(item.containerNo))]),
              _c("span", { staticStyle: { "margin-left": "30px" } }, [
                _vm._v(_vm._s(item.eqSize + item.eqType))
              ]),
              _c("br")
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "tip-line" }, [
        _c("div", [
          _c("i", { staticClass: "el-icon-info icon-line" }),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.ConfirmSendPackingInstructions")))
          ])
        ])
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.jyTakeContainer()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.yes")))]
          ),
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.no")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }